angular
  .module('memberCarAdd')
  .component('memberCarAdd', {
    template: require('./member-car-add.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService', 'Upload',
      function MemberCarAddViewController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService, Upload) {
        $rootScope.mainmenu = 'members';
        $rootScope.menu = 'users';
        const APIURL = envService.read('apiUrl'); // eslint-disable-line
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        this.user = $rootScope.user;
        this.brand = {};
        this.car = { MAKER_ID: -1, IMAGE: '', MAKER_NAME: '', MAKER_CD: '', CAR_NAME: '', CAR_CD: -1, CAR_NO: '', GOODS_ID: '', CAR_COLOR: '' };
        $resource(`${APIURL}/admin/cars/brands`).get((brands) => {
          this.brands = brands.brands;
        }, (err) => {
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
        this.upload = (files) => {
          if (files && files.length) {
            const file = files[0];
            Upload.upload({
              url: `${APIURL}/admin/file/usercars`,
              file,
            }).progress(() => {
            }).success((data, status, headers, config) => { // eslint-disable-line no-unused-vars
              this.car.IMAGE = data.url;
            });
          }
        };
        this.requestCars = () => {
          const selectedBrand = this.brands.filter(brand => brand.ID === parseInt(this.car.MAKER_CD, 10));
          this.car.MAKER_ID = selectedBrand[0].ID;
          this.car.MAKER_NAME = selectedBrand[0].MAKER_NAME;
          this.car.MAKER_CD = selectedBrand[0].MAKER_CD;
          $resource(`${APIURL}/admin/cars/${this.car.MAKER_CD}`).get((cars) => {
            this.cars = cars.cars;
          }, (err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
        this.selectCar = () => {
          const selectedCar = this.cars.filter(car => car.ID === parseInt(this.car.CAR_CD, 10));
          this.car.CAR_NAME = selectedCar[0].CAR_NAME;
          this.car.GOODS_ID = selectedCar[0].TB_GOODS_ID;
        };
        this.submit = () => {
          if (!this.car.MAKER_NAME || this.car.MAKER_NAME.length < 1) {
            alert($translate.instant('제조사를 선택해 주세요'));
            return;
          }
          if (!this.car.CAR_NAME || this.car.CAR_NAME.length < 1) {
            alert($translate.instant('차량을 선택해 주세요.'));
            return;
          }
          if (!this.car.CAR_COLOR || this.car.CAR_COLOR.length < 1) {
            alert($translate.instant('차량 색상을 입력해주세요.'));
            return;
          }
          if (!this.car.CAR_NO || this.car.CAR_NO.length < 1) {
            alert($translate.instant('차량번호를 입력해 주세요'));
            return;
          }
          let regist = true;
          $resource(`${APIURL}/admin/duplicatedCars/check/${this.car.CAR_NO}?CAR_CD=${this.car.CAR_CD}`).get().$promise
            .then((data) => {
              if (data && data.duplicatedCarNo) {
                if (!confirm($translate.instant('차량번호가 다른 차량과 중복된 번호입니다. 계속 진행하시겠습니까?'))) {
                  regist = false;
                  return Promise.resolve();
                }
                return Promise.resolve();
              }
              return Promise.resolve();
            })
            .then(() => {
              if (regist) {
                $resource(`${APIURL}/admin/users/${this.user.ID}/usercars`).save(this.car);
              }
            })
            .then(() => {
              if (regist) {
                $location.path('/members');
              }
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/member-car-add/member-car-add.component.js